"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"
import { TrendingUp, BarChart2, PieChart, FlaskConical, FileText, Bot, Filter, Briefcase, LineChart } from "lucide-react"
import { cn } from "@/lib/utils"

const navItems = [
  { href: "/stocks",         label: "종목목록",  icon: BarChart2 },
  { href: "/conditions",     label: "조건검색",  icon: Filter },
  { href: "/portfolio",      label: "포트폴리오", icon: PieChart },
  { href: "/backtest",       label: "관심종목",  icon: FlaskConical },
  { href: "/financials",     label: "재무제표",  icon: FileText },
  { href: "/trading",        label: "자동매매",  icon: Bot },
  { href: "/market-status",  label: "시장현황",  icon: LineChart },
]

const mobileNavItems = [
  { href: "/stocks",         label: "종목목록",  icon: BarChart2 },
  { href: "/conditions",     label: "조건검색",  icon: Filter },
  { href: "/portfolio",      label: "포트폴리오", icon: Briefcase },
  { href: "/backtest",       label: "관심종목",  icon: FlaskConical },
  { href: "/financials",     label: "재무제표",  icon: FileText },
  { href: "/trading",        label: "자동매매",  icon: Bot },
  { href: "/market-status",  label: "시장현황",  icon: LineChart },
]

export default function Sidebar() {
  const pathname = usePathname()
  const isActive = (href: string) => pathname === href || pathname.startsWith(href + "/")

  return (
    <>
      {/* md 이상: 기존 사이드바 */}
      <aside className="hidden md:flex h-full w-56 flex-col bg-zinc-900">
        <div className="flex items-center gap-2 px-5 py-5">
          <TrendingUp className="size-6 text-emerald-400" />
          <span className="text-lg font-semibold tracking-tight text-white">JaceStock</span>
        </div>

        <nav className="flex flex-1 flex-col gap-1 px-3">
          {navItems.map(({ href, label, icon: Icon }) => {
            const active = isActive(href)
            return (
              <Link
                key={href}
                href={href}
                className={cn(
                  "flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors",
                  active
                    ? "bg-emerald-500/10 text-emerald-400"
                    : "text-zinc-400 hover:bg-zinc-800 hover:text-zinc-100"
                )}
              >
                <Icon className="size-4 shrink-0" />
                {label}
              </Link>
            )
          })}
        </nav>
      </aside>

      {/* md 미만: 하단 탭바 */}
      <nav className="fixed inset-x-0 bottom-0 z-50 flex h-16 items-stretch border-t border-zinc-800 bg-zinc-900 md:hidden">
        {mobileNavItems.map(({ href, label, icon: Icon }) => {
          const active = isActive(href)
          return (
            <Link
              key={href}
              href={href}
              className={cn(
                "flex min-w-[44px] flex-1 flex-col items-center justify-center gap-0.5 text-[11px] font-medium transition-colors",
                active ? "text-emerald-400" : "text-zinc-500"
              )}
            >
              <Icon className="size-5" />
              <span>{label}</span>
            </Link>
          )
        })}
      </nav>
    </>
  )
}
